export default "__VITE_ASSET__C_jU2UQC__"